import css from 'styled-jsx/css';

const styles = css.global`#modal-remove-insurance.modal-component .modal-surface {
  border-radius: 4px;
  padding: 16px;
  height: auto;
  min-height: unset;
  max-height: unset;
  max-width: 288px;
}

#modal-remove-insurance .text-title {
  color: #222;
  font-family: SantanderHeadline;
  font-weight: 400;
  font-size: 24px;
  line-height: 36px;
  letter-spacing: 0%;
  vertical-align: middle;
  margin: 0 0 8px;
}

#modal-remove-insurance .text-desc {
  color: #222;
  font-family: SantanderText;
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0%;
  vertical-align: middle;
  margin: 0 0 24px;
  max-width: 256px;
}

#modal-remove-insurance #btn-remove-insurance {
  margin-bottom: 16px;
}

@media (min-width: 992px) {
  #modal-remove-insurance.modal-component .modal-surface {
    max-width: 460px;
    padding: 24px;
  }

  #modal-remove-insurance .text-desc {
    max-width: 412px;
  }

  #modal-remove-insurance .btns {
    display: flex;
    flex-direction: row-reverse;
    justify-content: flex-start;
    gap: 16px;
  }

  #modal-remove-insurance .btns button {
    max-width: 144px;
    margin: 0 !important;
  }
}
`;

export default styles;